import defaultBingoBoardImg from '../../assets/bingo/bingo_board_social.webp';
import type { MetagameTokenPackageBundle } from '../../dto/metagames.types';

import type { SubscriptionCoinType, SubscriptionPlanEnhanced } from './types';

export class SubscriptionUtils {
  static getCardsCounts(packageBundles: MetagameTokenPackageBundle[], coinType?: SubscriptionCoinType): number {
    return packageBundles
      .filter(
        (bundle) => bundle.bundleType === 'metagameToken' && (!coinType || bundle.bundlePayload.coinType === coinType),
      )
      .reduce((total, bundle) => total + Number(bundle.bundlePayload.amount), 0);
  }

  static getCurrencySymbol(packageBundles: MetagameTokenPackageBundle[], coinType: SubscriptionCoinType): string {
    const packageBundle = packageBundles.find(
      (bundle) => bundle.bundleType === 'metagameToken' && bundle.bundlePayload.coinType === coinType,
    );
    return packageBundle?.bundlePayload.currencySymbol || defaultBingoBoardImg;
  }

  static getCardsInfo(packageBundles: MetagameTokenPackageBundle[]): {
    gcCards: number;
    scCards: number;
    gcSymbol: string;
    scSymbol: string;
  } {
    return {
      gcCards: this.getCardsCounts(packageBundles, 'GC'),
      scCards: this.getCardsCounts(packageBundles, 'CASH'),
      gcSymbol: this.getCurrencySymbol(packageBundles, 'GC'),
      scSymbol: this.getCurrencySymbol(packageBundles, 'CASH'),
    };
  }

  static checkIfHigherTierPlanExists(availablePlans: SubscriptionPlanEnhanced[], currentPlanPrice: number): boolean {
    const higherTierPlan = availablePlans.find((plan) => plan.price > currentPlanPrice);
    return !!higherTierPlan;
  }
}
